export enum SupplyDemandType {
  /**
   * 供应
   */
  SUPPLY = 0,

  /**
   * 需求
   */
  DEMAND = 1
}
